import { useState } from 'react';
import { Order, DateRangeParams } from '../types';
import { getOrdersByDateRange, deleteOrder } from '../services';

export const useOrders = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOrdersByDateRange = async (params: DateRangeParams) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getOrdersByDateRange(params);
      setOrders(data);
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Error desconocido al obtener órdenes';
      setError(errorMessage);
      console.error('Error en useOrders:', errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const removeOrder = async (id: number) => {
    setLoading(true);
    setError(null);
    
    try {
      await deleteOrder(id);
      // Remover la orden de la lista local
      setOrders(prevOrders => prevOrders.filter(order => order.id !== id));
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Error desconocido al eliminar la orden';
      setError(errorMessage);
      console.error('Error en useOrders:', errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    orders,
    loading,
    error,
    fetchOrdersByDateRange,
    removeOrder
  };
};
